import { Button, Typography } from "antd";

const { Text } = Typography;

export function plural(quantidade, singular, varios) {
  return `${quantidade} ${quantidade === 1 ? singular : varios}`;
}

export default function ResumoDeContatos({
  titulo,
  detalhe,
  botao,
  onAbrir,
  carregando,
}) {
  return (
    <div
      style={{
        marginTop: 8,
        border: "1px solid #e3e8ef",
        background: "#f3f6fa",
        borderRadius: 8,
        padding: "12px 14px",
        display: "flex",
        gap: 12,
        alignItems: "center",
        flexWrap: "wrap",
      }}>
      <div style={{ flex: 1, minWidth: 200 }}>
        <Text strong>{carregando ? "Carregando contatos…" : titulo}</Text>
        {!carregando && detalhe && (
          <Text type="secondary" style={{ display: "block", fontSize: 13 }}>
            {detalhe}
          </Text>
        )}
      </div>
      <Button onClick={onAbrir}>{botao}</Button>
    </div>
  );
}
